import * as $ from 'jquery'
import { AppService } from './../../service/app.service';
import { AuthService } from './../../service/auth.service';
import { SessionService, ISessionStoreReturnModel } from './../../service/session.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { SidebarService } from './../../service/sidebar.service';
import { Title } from "@angular/platform-browser";
import { AccessibilityService } from '../../service/accessibility.service';
import { Recovery } from './recovery';

@Component({
  selector: 'app-recovery',
  templateUrl: 'recovery.component.html',
  styleUrls: ['recovery.component.scss']
})
export class RecoveryComponent implements OnInit {

  inverted: string;
  returnPIN: string;
  notFound: boolean = false;
  notAllowed: boolean = false;
  errorMessage: string;
  sessionTimeout: string;

  formGroup = new FormGroup({
    lastName: new FormControl(null,
    {
      validators: [Validators.required],
      updateOn: 'submit'
    }),
    birthYear: new FormControl(null,
    {
      validators: [Validators.required, Validators.minLength(4), Validators.maxLength(4)],
      updateOn: 'submit'
    }),
    zipCode: new FormControl(null,
    {
      validators: [Validators.required, Validators.minLength(5), Validators.maxLength(6)],
      updateOn: 'submit'
    }),
    ssn: new FormControl(null,
    {
      validators: [Validators.required, Validators.minLength(4), Validators.maxLength(4)],
      updateOn: 'submit'
    })
  });

  validationMessages = {
    lastName: {
      Required: 'Please enter your Member ID.'
    },
    birthYear: {
      Required: 'Please enter a year of birth.',
      MinLength: 'Your year of birth must be at least 4 digits.',
      MaxLength: 'Your year of birth should only be at most 4 digits.'
    },
    zipCode: {
      Required: 'Please enter a ZIP code.',
      MinLength: 'Your ZIP must be at least 5 digits.',
      MaxLength: 'Your ZIP should only be at most 6 digits.'
    },
    ssn: {
      Required: 'Please enter the last four of your SSN.',
      MinLength: 'Your last four must be at least 4 digits.',
      MaxLength: 'Your last four should only be at most 4 digits.'
    }
  }

  constructor(
    private http: HttpClient,
    private router: Router,
    private titleService: Title,
    private appService: AppService,
    private accessService: AccessibilityService) {
    this.titleService.setTitle("Forgot Your PIN? - 2026 CAPE Contract Ratification");
  }

  ngOnInit() {
    this.clearAll();
    this.inverted = this.accessService.current.contrast;
    this.skipLink();
  }

  gotoSettings() {
    this.router.navigate(['/settings']);
  }

  keydownSettings(e) {
    e.preventDefault();

    if (e.keyCode === 32 || e.keyCode === 13) {
      this.gotoSettings();
    }
  }

  keydownSubmitForm(e) {
    e.preventDefault();

    if (e.keyCode === 32 || e.keyCode === 13) {
      this.submit();
    }
  }

  skipLink() {
    $('h1.titleHeading').focus();
  }

  clearAll() {
    this.appService.clearAll();
  }

  checkPIN(recoveryObj: Recovery) {
    this.http.post<any>('recovery/pin', recoveryObj).subscribe({
      next: data => {
        document.cookie = "pin = " + data + "; secure;";
        this.router.navigate(['/#']);
      },
      error: error => {
        if (error.error.text == "Not Found")
          this.userNotFound();
        if (error.error.text == "Bad Request")
          this.userBlocked();
      }
    });
  }

  userNotFound() {
    this.notAllowed = false;
    this.notFound = true;
  }

  userBlocked() {
    this.notFound = false;
    this.notAllowed = true;
  }

  submit() {
    if (this.formGroup.valid) {
      this.checkPIN(this.formGroup.value);
    } else {
      this.formGroup.get('lastName').markAsTouched();
      this.formGroup.get('birthYear').markAsTouched();
      this.formGroup.get('zipCode').markAsTouched();
      this.formGroup.get('ssn').markAsTouched();
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/features/recovery/recovery.component.ts